import React from 'react';
import PropTypes from 'prop-types';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

import './BookingSummary.scss';

const BookingSummary = (props) => {
  const {
    guestName,
    phone,
    email,
    condensed,
  } = props;

  let phoneObj;
  if (phone) {
    phoneObj = parsePhoneNumberFromString(phone);
  }

  const hasValidPhone = phoneObj
    && typeof phoneObj.countryCallingCode !== 'undefined'
    && typeof phoneObj.formatNational === 'function';

  return (
    <div className="BookingSummary">
      <p>{`Booked on behalf of ${guestName}`}</p>
      {!condensed && hasValidPhone && (
        <>
          <p>{`+${phoneObj.countryCallingCode} ${phoneObj.formatNational()}`}</p>
          <p>{email}</p>
        </>
      )}
      {!condensed && !hasValidPhone && email && <p>{email}</p>}
    </div>
  );
};

BookingSummary.propTypes = {
  guestName: PropTypes.string.isRequired,
  phone: PropTypes.string,
  email: PropTypes.string,
  condensed: PropTypes.bool,
};

BookingSummary.defaultProps = {
  phone: '',
  email: '',
  condensed: false,
};

BookingSummary.displayName = 'BookingSummary';
export default BookingSummary;
